import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ItemReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { ItemsEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('item', ItemReducer),
    EffectsModule.forFeature([ItemsEffects])
  ]
})
export class ItemStoreModule { }
